import { createContext, useContext } from 'react';
import { IModal, IModalApi } from '@vivli/shared/infrastructure/interface';

// Modal wiring is split into two contexts so that opening/closing a modal does not re-render the
// whole app. The API context holds the stable callbacks (confirm/message/dismiss/...) and its value
// reference never changes; the state context holds the changing `modals` array and is consumed only
// by the modal host (ModalContextWrapper). See ModalProvider. (DEV-485 re-render fix)
export const ModalApiContext = createContext<IModalApi>(null);
export const ModalStateContext = createContext<IModal[]>([]);

export const useModalApiContext = () => useContext(ModalApiContext);
export const useModalStateContext = () => useContext(ModalStateContext);
